import { GridIcon } from '../../icons/GridIcon';
import { ListIcon } from '../../icons/ListIcon';
import { ToggleButton, ToggleWrapper } from './ViewToggle.styles';
import type { ViewMode, ViewToggleOption, ViewToggleProps } from './ViewToggle.types';

const DEFAULT_OPTIONS: ViewToggleOption<ViewMode>[] = [
  { value: 'grid', label: 'Grid view', Icon: GridIcon },
  { value: 'compact', label: 'Compact view', Icon: ListIcon },
];

export function ViewToggle(props: ViewToggleProps<ViewMode>): JSX.Element;
export function ViewToggle<T extends string>(
  props: ViewToggleProps<T> & { options: ViewToggleOption<T>[] }
): JSX.Element;
export function ViewToggle<T extends string>({
  value,
  onChange,
  options,
  gridLabel,
  compactLabel,
}: ViewToggleProps<T>) {
  const resolvedOptions: ViewToggleOption<string>[] = options ?? DEFAULT_OPTIONS;
  const labelOverrides: Record<string, string | undefined> = {
    grid: gridLabel,
    compact: compactLabel,
  };

  return (
    <ToggleWrapper role="group">
      {resolvedOptions.map(({ value: optionValue, label, Icon }) => {
        const resolvedLabel = labelOverrides[optionValue] ?? label;
        return (
          <ToggleButton
            key={optionValue}
            type="button"
            $active={value === optionValue}
            aria-label={resolvedLabel}
            aria-pressed={value === optionValue}
            onClick={() => onChange(optionValue as T)}
          >
            <Icon />
          </ToggleButton>
        );
      })}
    </ToggleWrapper>
  );
}
